<template>
  <d2-container>
    <template slot="header">
      <el-input v-model="query.keyword" clearable size="small" placeholder="组织ID/名称" style="width: 220px; margin-right: 8px" @keyup.enter.native="load"></el-input>
      <el-select v-model="query.status" clearable size="small" placeholder="状态" style="width: 120px; margin-right: 8px">
        <el-option label="启用" :value="1"></el-option>
        <el-option label="停用" :value="0"></el-option>
      </el-select>
      <el-button type="primary" size="small" icon="el-icon-search" @click="load">搜索</el-button>
      <el-button type="primary" size="small" icon="el-icon-plus" @click="openOrg()">新增组织</el-button>
    </template>

    <el-table size="small" stripe border :data="records" v-loading="loading">
      <el-table-column prop="id" label="组织ID" width="160"></el-table-column>
      <el-table-column prop="name" label="组织名称" min-width="180"></el-table-column>
      <el-table-column prop="ownerAccountId" label="所有者账户" width="150"></el-table-column>
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.status === 1 ? 'success' : 'info'">{{ scope.row.status === 1 ? '启用' : '停用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
      <el-table-column label="操作" width="360" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="openOrg(scope.row)">编辑</el-button>
          <el-button size="mini" @click="openSettings(scope.row)">设置</el-button>
          <el-button size="mini" @click="openMembers(scope.row)">成员</el-button>
          <el-button size="mini" @click="openLogs(scope.row)">邀请/审计</el-button>
        </template>
      </el-table-column>
    </el-table>

    <template slot="footer">
      <el-pagination
        :current-page.sync="query.currentPage"
        :page-size="query.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSize"
        @current-change="handlePage"
      ></el-pagination>
    </template>

    <el-dialog :title="orgForm.id ? '编辑组织' : '新增组织'" :visible.sync="orgDialog" width="560px">
      <el-form :model="orgForm" label-width="110px">
        <el-form-item label="组织名称" required>
          <el-input v-model="orgForm.name"></el-input>
        </el-form-item>
        <el-form-item label="Logo">
          <upload-image
            v-model="orgForm.logo"
            :max="1"
            :show-tips="false"
            :width="120"
          ></upload-image>
        </el-form-item>
        <el-form-item label="所有者账户" required>
          <account-selector
            v-model="orgForm.ownerAccountId"
            :disabled="!!orgForm.id"
            placeholder="请选择所有者账户"
          ></account-selector>
        </el-form-item>
        <el-form-item label="状态" v-if="orgForm.id">
          <el-radio-group v-model="orgForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="orgDialog = false">取消</el-button>
        <el-button type="primary" @click="saveOrg">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="组织设置" :visible.sync="settingDialog" width="520px">
      <el-form :model="settingForm" label-width="180px">
        <el-form-item label="普通成员可用组织无限积分">
          <el-switch v-model="settingForm.memberCanUsePoints"></el-switch>
        </el-form-item>
        <el-form-item label="普通成员可编辑画布">
          <el-switch v-model="settingForm.memberCanManageCanvas"></el-switch>
        </el-form-item>
        <el-form-item label="启用服务商能力">
          <el-switch v-model="settingForm.clientServiceProvider"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="settingDialog = false">取消</el-button>
        <el-button type="primary" @click="saveSettings">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="'成员管理 - ' + currentOrgName" :visible.sync="memberDialog" width="860px">
      <div class="dialog-toolbar">
        <el-input v-model="memberQuery.accountId" clearable size="small" placeholder="账户ID" style="width: 180px"></el-input>
        <el-select v-model="memberQuery.role" clearable size="small" placeholder="角色" style="width: 140px">
          <el-option label="管理员" value="ADMIN"></el-option>
          <el-option label="财务" value="BILLING"></el-option>
          <el-option label="成员" value="MEMBER"></el-option>
        </el-select>
        <el-button size="small" type="primary" @click="loadMembers">搜索</el-button>
        <el-button size="small" type="success" @click="openMember()">新增成员</el-button>
      </div>
      <el-table size="small" stripe border :data="members" v-loading="memberLoading">
        <el-table-column prop="id" label="ID" width="90"></el-table-column>
        <el-table-column prop="accountId" label="账户ID" width="150"></el-table-column>
        <el-table-column prop="role" label="角色" width="120"></el-table-column>
        <el-table-column prop="status" label="状态" width="90"></el-table-column>
        <el-table-column prop="joinedAt" label="加入时间" width="170"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="openMember(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" :disabled="scope.row.role === 'OWNER'" @click="removeMember(scope.row)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :title="memberForm.id ? '编辑成员' : '新增成员'" :visible.sync="memberFormDialog" width="480px">
      <el-form :model="memberForm" label-width="100px">
        <el-form-item label="账户ID" required>
          <account-selector
            v-model="memberForm.accountId"
            :disabled="!!memberForm.id"
            placeholder="请选择成员账户"
          ></account-selector>
        </el-form-item>
        <el-form-item label="角色" required>
          <el-select v-model="memberForm.role" style="width: 100%">
            <el-option label="管理员" value="ADMIN"></el-option>
            <el-option label="财务" value="BILLING"></el-option>
            <el-option label="成员" value="MEMBER"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="memberForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="memberFormDialog = false">取消</el-button>
        <el-button type="primary" @click="saveMember">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="'邀请/审计 - ' + currentOrgName" :visible.sync="logDialog" width="920px">
      <el-tabs v-model="logTab" @tab-click="loadLogs">
        <el-tab-pane label="邀请记录" name="invitation">
          <el-table size="small" border stripe :data="invitations">
            <el-table-column prop="id" label="ID" width="90"></el-table-column>
            <el-table-column prop="inviteeAccountId" label="被邀请账户" width="140"></el-table-column>
            <el-table-column prop="role" label="角色" width="110"></el-table-column>
            <el-table-column prop="status" label="状态" width="120"></el-table-column>
            <el-table-column prop="expireAt" label="过期时间" width="170"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="审计日志" name="audit">
          <el-table size="small" border stripe :data="audits">
            <el-table-column prop="id" label="ID" width="90"></el-table-column>
            <el-table-column prop="operatorAccountId" label="操作者" width="140"></el-table-column>
            <el-table-column prop="action" label="动作" width="160"></el-table-column>
            <el-table-column prop="targetType" label="目标类型" width="120"></el-table-column>
            <el-table-column prop="targetId" label="目标ID" width="140"></el-table-column>
            <el-table-column prop="detail" label="详情" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="时间" width="170"></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </d2-container>
</template>

<script>
import {
  getOrganizations,
  saveOrganization,
  updateOrganization,
  getOrganizationSettings,
  updateOrganizationSettings,
  getOrganizationMembers,
  saveOrganizationMember,
  removeOrganizationMember,
  getOrganizationInvitations,
  getOrganizationAudits
} from '@/api/ai/rights'
import AccountSelector from '@/components/ai-rights/AccountSelector.vue'
import UploadImage from '@/components/uploadImage/index.vue'

export default {
  name: 'aiOrganizationManager',
  components: {
    AccountSelector,
    UploadImage
  },
  data () {
    return {
      query: { currentPage: 1, pageSize: 20, keyword: '', status: '' },
      records: [],
      total: 0,
      loading: false,
      orgDialog: false,
      orgForm: {},
      settingDialog: false,
      settingForm: {},
      currentOrg: null,
      memberDialog: false,
      memberLoading: false,
      memberQuery: { currentPage: 1, pageSize: 100, organizationId: null, accountId: '', role: '' },
      members: [],
      memberFormDialog: false,
      memberForm: {},
      logDialog: false,
      logTab: 'invitation',
      invitations: [],
      audits: []
    }
  },
  computed: {
    currentOrgName () {
      return this.currentOrg ? `${this.currentOrg.name || ''}(${this.currentOrg.id})` : ''
    }
  },
  created () {
    this.load()
  },
  methods: {
    normalizePage (res) {
      return res || { records: [], total: 0 }
    },
    load () {
      this.loading = true
      getOrganizations(this.query).then(res => {
        const page = this.normalizePage(res)
        this.records = page.records || []
        this.total = Number(page.total || 0)
      }).finally(() => {
        this.loading = false
      })
    },
    handleSize (size) {
      this.query.pageSize = size
      this.load()
    },
    handlePage (page) {
      this.query.currentPage = page
      this.load()
    },
    openOrg (row) {
      this.orgForm = row ? Object.assign({}, row) : { name: '', logo: '', ownerAccountId: '', status: 1 }
      this.orgDialog = true
    },
    saveOrg () {
      const request = this.orgForm.id ? updateOrganization(this.orgForm) : saveOrganization(this.orgForm)
      request.then(() => {
        this.$message.success('保存成功')
        this.orgDialog = false
        this.load()
      })
    },
    openSettings (row) {
      this.currentOrg = row
      getOrganizationSettings({ organizationId: row.id }).then(res => {
        this.settingForm = Object.assign({ organizationId: row.id }, res || {})
        this.settingDialog = true
      })
    },
    saveSettings () {
      updateOrganizationSettings(this.settingForm).then(() => {
        this.$message.success('设置已保存')
        this.settingDialog = false
      })
    },
    openMembers (row) {
      this.currentOrg = row
      this.memberQuery.organizationId = row.id
      this.memberDialog = true
      this.loadMembers()
    },
    loadMembers () {
      this.memberLoading = true
      getOrganizationMembers(this.memberQuery).then(res => {
        this.members = (res && res.records) || []
      }).finally(() => {
        this.memberLoading = false
      })
    },
    openMember (row) {
      this.memberForm = row
        ? Object.assign({}, row)
        : { organizationId: this.currentOrg.id, accountId: '', role: 'MEMBER', status: 1 }
      this.memberFormDialog = true
    },
    saveMember () {
      saveOrganizationMember(this.memberForm).then(() => {
        this.$message.success('成员已保存')
        this.memberFormDialog = false
        this.loadMembers()
      })
    },
    removeMember (row) {
      this.$confirm('确认移除该成员？', '提示').then(() => {
        removeOrganizationMember({ id: row.id }).then(() => {
          this.$message.success('已移除')
          this.loadMembers()
        })
      })
    },
    openLogs (row) {
      this.currentOrg = row
      this.logDialog = true
      this.loadLogs()
    },
    loadLogs () {
      if (!this.currentOrg) return
      if (this.logTab === 'invitation') {
        getOrganizationInvitations({ organizationId: this.currentOrg.id, currentPage: 1, pageSize: 100 }).then(res => {
          this.invitations = (res && res.records) || []
        })
      } else {
        getOrganizationAudits({ organizationId: this.currentOrg.id, currentPage: 1, pageSize: 100 }).then(res => {
          this.audits = (res && res.records) || []
        })
      }
    }
  }
}
</script>

<style scoped>
.dialog-toolbar {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}
</style>
